import { RouteNamesEnum } from '@/enums/RouteNamesEnum';

const HomeRoutes = [
    {
        path: '/devices',
        component: () => import('../components/general/RootModule.vue'),
        meta: {
            title: 'DevicesModule.module-name',
            icon: 'mdi-thermometer',
            auth: {
                required: true,
            },
            showInMenu: true,
            moduleRoot: true,
        },
        children: [
            {
                path: ':id(\\d+|new)?',
                name: RouteNamesEnum.Home,
                component: () => import('../views/devices-module/DevicesView.vue'),
                meta: {
                    title: 'DevicesModule.devices',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                },
            },
        ],
    },
];

export default HomeRoutes;
